export const wheelSoundEnabledChecker = ({ isWheelSpinSoundEnabled, isWheelButtonSoundEnabled, isWheelResultSoundEnabled, isenableWheelSound, updateSetting }) => {
  if (isenableWheelSound === undefined) {
    updateSetting('enableWheelSound', false);
    updateSetting('isWheelSpinSoundEnabled', false);
    updateSetting('isWheelButtonSoundEnabled', false);
    updateSetting('isWheelResultSoundEnabled', false);
  }
  if (isWheelSpinSoundEnabled || isWheelButtonSoundEnabled || isWheelResultSoundEnabled) {
    updateSetting('enableWheelSound', true);
  }
  if (!isWheelSpinSoundEnabled && !isWheelButtonSoundEnabled && !isWheelResultSoundEnabled) {
    updateSetting('enableWheelSound', false);
  }
};
